module.exports = __webpack_public_path__ + "img/andover.c2d60782.png";